import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SERVER_API_URL} from 'src/app/app.constants';
import {IRuleMySuffix} from 'src/app/shared/model/rule-my-suffix.model';
import {createRequestOption} from 'src/app/shared/util/request-util';


type EntityResponseType = HttpResponse<IRuleMySuffix>;
type EntityArrayResponseType = HttpResponse<IRuleMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class RuleMySuffixService {
    private resourceUrl = SERVER_API_URL + 'api/rules';
    private resourceUrlForEdit = SERVER_API_URL + 'api/rules/edit';
    private resourceRuleUrl = SERVER_API_URL + 'api/rules/LandPType';
    private resourceStorageRuleUrl  = SERVER_API_URL +'api/storage-rules';
    private countriesByContinents  = SERVER_API_URL +'api/users/get-country-cont-reg';
    constructor(private http: HttpClient) { }

    create(rule: IRuleMySuffix): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(rule);
        return this.http
            .post<IRuleMySuffix>(this.resourceUrl, copy, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    update(rule: IRuleMySuffix): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(rule);
        return this.http
            .put<IRuleMySuffix>(this.resourceUrl, copy, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IRuleMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    findRuleData(id: number,url ,ruleType?:any  ): Observable<any> {
        let URL 
        if(ruleType =='STORAGE'){
            URL = this.resourceStorageRuleUrl +url;
        }else{
            URL = this.resourceUrl +url;
        }
        

        return this.http
            .get<any>(`${URL}/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }
    findForEdit(id: number): Observable<EntityResponseType> {

        return this.http
            .get<IRuleMySuffix>(`${this.resourceUrlForEdit}/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IRuleMySuffix[]>(this.resourceUrl, { params: options, observe: 'response' })
            .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    private convertDateFromClient(rule: IRuleMySuffix): IRuleMySuffix {
        const copy: IRuleMySuffix = Object.assign({}, rule, {
            inceptionDate: rule.inceptionDate != null ? rule.inceptionDate.toJSON() : null,
            expiryDate: rule.expiryDate != null ? rule.expiryDate.toJSON() : null
        });
        return copy;
    }

    private convertDateFromServer(res: EntityResponseType): EntityResponseType {
        res.body.inceptionDate = res.body.inceptionDate != null ?  new Date(res.body.inceptionDate) : null;
        res.body.expiryDate = res.body.expiryDate != null ?  new Date(res.body.expiryDate) : null;
        return res;
    }

    private convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
        res.body.forEach((rule: IRuleMySuffix) => {
            rule.inceptionDate = rule.inceptionDate != null ?  new Date(rule.inceptionDate) : null;
            rule.expiryDate = rule.expiryDate != null ?  new Date(rule.expiryDate) : null;
        });
        return res;
    }
    findwithRuleAndPacking(id: number, scopeId: number): Observable<EntityResponseType> {
        return this.http
            .get<IRuleMySuffix>(`${this.resourceRuleUrl}/${id}/${scopeId}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<IRuleMySuffix>(`${this.resourceUrlForEdit}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }

    get(url:string){
        return this.http.get<any>(SERVER_API_URL+url, { observe: 'response' });
    }

    getSubRuleDataFromCertificateRequest(scopeRuleId,crId) {
        return this.http.get<any>(SERVER_API_URL+'api/get-sub-rule-from-certificate-request/'+scopeRuleId+'/'+crId, { observe: 'response' });
    }

    getCountriesByContinents() {
        return this.http.get<any>(this.countriesByContinents, {observe : 'response'});
    }

    getCountriesByContinentsByRuleId(id:number,type:string) {
        return this.http.get<any>(this.countriesByContinents+'/'+id+'/'+type, {observe : 'response'});
    }
}
